<oct-check-box (change)="onCheckAllChange($event)" *ngIf="selectAllOption" [checked]="checkAll"
               checkBoxName="selectAll-{{checkBoxListName}}"
               checkboxLabel="Select All"></oct-check-box>
<oct-check-box (change)="onCheckChange(item, $event)" *ngFor="let item of data; let i = index"
               [checked]="item.checked"
               [index]="i+1"
               [ngStyle]="{color: item.color}"
               checkBoxName="{{checkBoxListName}}"
               checkboxLabel="{{item.text || item.FULL_NAME}} " value="{{item.id}}"></oct-check-box>
